import { useEffect, useState } from "react";
import { Phone, Menu, X, Facebook } from "lucide-react";
import { NAV } from "@/constants/testIds";

const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=100063568961120";

const links = [
  { id: "services", label: "Services", testId: NAV.linkServices },
  { id: "area", label: "Service Area", testId: NAV.linkArea },
  { id: "about", label: "About", testId: NAV.linkAbout },
  { id: "gallery", label: "Gallery", testId: NAV.linkGallery },
  { id: "contact", label: "Contact", testId: NAV.linkContact },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b-2 transition-colors ${
        scrolled ? "bg-white/95 backdrop-blur-xl border-[#E5E7EB]" : "bg-white border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-24 sm:h-28 flex items-center justify-between">
        <button
          data-testid={NAV.logo}
          onClick={() => scrollTo("top")}
          className="flex items-center gap-3 group"
          aria-label="JJH Painting & Pressure Washing"
        >
          <img
            src="/img/jjh-logo.png"
            alt="JJH Painting & Pressure Washing LLC"
            className="h-16 sm:h-20 w-auto"
          />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-semibold uppercase tracking-wider text-[#334155] hover:text-[#0EA5E9] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid={NAV.callBtn}
          href="tel:8505416842"
          className="hidden md:inline-flex items-center gap-2 bg-[#0EA5E9] hover:bg-[#0284C7] transition-colors text-white px-5 py-3 font-heading font-bold uppercase tracking-wider"
        >
          <Phone size={16} />
          <span>850-541-6842</span>
        </a>

        <a
          data-testid="nav-facebook"
          href={FACEBOOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          className="hidden md:inline-flex items-center justify-center h-12 w-12 border-2 border-[#334155] text-[#334155] hover:bg-[#0EA5E9] hover:text-white hover:border-[#0EA5E9] transition-colors ml-2"
        >
          <Facebook size={18} />
        </a>

        <button
          data-testid={NAV.mobileToggle}
          onClick={() => setOpen((s) => !s)}
          className="md:hidden p-2 text-[#334155]"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-2 border-[#E5E7EB] bg-white">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`${l.testId}-mobile`}
                onClick={() => scrollTo(l.id)}
                className="text-left text-base font-semibold uppercase tracking-wider text-[#334155]"
              >
                {l.label}
              </button>
            ))}
            <a
              href="tel:8505416842"
              data-testid={`${NAV.callBtn}-mobile`}
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#0EA5E9] text-white px-5 py-3 font-heading font-bold uppercase tracking-wider"
            >
              <Phone size={16} /> 850-541-6842
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
